import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

import { Button } from 'react-bootstrap';

class TagHider extends PureComponent {
  handleClick = tag => {
    this.props.onClick(tag);
  };

  render() {
    const { tag, isPending } = this.props;
    let classNames = ['HideTag', tag.displayClass];

    if (isPending) {
      classNames.push('pending');
    }
    return (
      <div className={`HideTagContainer ${tag.displayClass}`}>
        <Button
          className={classNames.join(' ')}
          onClick={() => this.handleClick(tag)}
        >
          {tag.name}
        </Button>
      </div>
    );
  }
}

TagHider.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    schema: PropTypes.string,
    displayClass: PropTypes.string,
  }).isRequired,
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideTags: actions.hideTags,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TagHider);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Recommendations/RecommendationHideMenu/TagHider.js